/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { HeroSection } from '@/components/sections/HeroSection'
import { ServicesSection } from '@/components/sections/ServicesSection'
import { AboutOverviewSection } from '@/components/sections/AboutOverviewSection'
import { TestimonialsSection } from '@/components/sections/TestimonialsSection'
import { BlogPreviewSection } from '@/components/sections/BlogPreviewSection'
import { ContactCTASection } from '@/components/sections/ContactCTASection'
import { siteConfig } from '@/data'

export const Route = createFileRoute('/_public/')({
  component: HomePage,
})

function HomePage(){
  return (
    <>
      <Helmet>
        <title>{siteConfig.name} | Expert Tax Consultancy in Kenya</title>
        <meta name="description" content={siteConfig.description} />
        <meta property="og:title" content={siteConfig.name} />
        <meta property="og:description" content={siteConfig.description} />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://rosewoodtax.co.ke" />
      </Helmet>
      <HeroSection />
      <AboutOverviewSection />
      <ServicesSection />
      <TestimonialsSection />
      <BlogPreviewSection />
      <ContactCTASection />
    </>
  )
}